import "./Home.module.css";
import VoltMainHeader from "@/reusable_sections/Header";
import DonChuyCuidamosALosQueMasQuieres from "./sections/DonChuyCuidamosALosQueMasQuieres";
import ServiceClarity from "./sections/ServiceClarity";
import OurSeasonalIzakaya from "./sections/OurSeasonalIzakaya";
import TheSBuddyAdvantage from "./sections/TheSBuddyAdvantage";
import WordFromTheField from "./sections/WordFromTheField";
import StartYourProject from "./sections/StartYourProject";
import AccountTypesSelector from "./sections/AccountTypesSelector";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <VoltMainHeader />
      <DonChuyCuidamosALosQueMasQuieres />
      <ServiceClarity />
      <OurSeasonalIzakaya />
      <TheSBuddyAdvantage />
      <WordFromTheField />
      <AccountTypesSelector />
      <StartYourProject />
      <Footer />
    </div>;
}